import { StatusItem } from "./styles";

export const TranscriptionStatus = (
  status: number,
  t: (key: string) => string,
) => {
  switch (status) {
    case 0:
      return <StatusItem>{t("transcription.status.inQueue")}</StatusItem>;
    case 1:
      return <StatusItem>{t("transcription.status.loadingVideo")}</StatusItem>;
    case 2:
      return (
        <StatusItem>{t("transcription.status.extractingAudio")}</StatusItem>
      );
    case 3:
      return (
        <StatusItem>{t("transcription.status.transferringAudio")}</StatusItem>
      );
    case 4:
      return (
        <StatusItem>{t("transcription.status.transcribingAudio")}</StatusItem>
      );
    case 5:
      return <StatusItem>{t("transcription.status.finishing")}</StatusItem>;
    case 6:
      return <StatusItem>{t("transcription.status.finished")}</StatusItem>;
    case 7:
      return <StatusItem>{t("transcription.status.cancelled")}</StatusItem>;
    case 8:
      return (
        <StatusItem>{t("transcription.status.videoLoadError")}</StatusItem>
      );
    case 9:
      return (
        <StatusItem>
          {t("transcription.status.audioExtractionError")}
        </StatusItem>
      );
    case 10:
      return (
        <StatusItem>{t("transcription.status.audioTransferError")}</StatusItem>
      );
    case 11:
      return (
        <StatusItem>{t("transcription.status.transcriptionError")}</StatusItem>
      );
    case 12:
      return (
        <StatusItem>{t("transcription.status.creditDebitError")}</StatusItem>
      );
    case 13:
      return (
        <StatusItem>{t("transcription.status.processingError")}</StatusItem>
      );
    case 14:
      return (
        <StatusItem>{t("transcription.status.insufficientBalance")}</StatusItem>
      );
    default:
      return <StatusItem>{t("transcription.status.inQueue")}</StatusItem>;
  }
};
